
import {mean, variance, extent, range, quantile} from 'd3'

export const encodeUrl64 = (value:any) => {    
  return btoa(value).replace(/=/g,'').replace(/\+/g,'-').replace(/\//g,'_')
}


export const decodeUrl64 = (value:string) => {
  const data = value.replace(/-/g,'+').replace(/_/g,'/')  
  return atob(data.padEnd((4 - data.length)%4 + data.length,'='))
}
